import { hotjarEvent } from 'src/modules/hotjar';
import type { Action } from 'src/types';

export const createHotjarMiddleware =
  () => () => (next: (action: Action) => void) => (action: Action) => {
    const { event } = action?.meta?.hotjar ?? {};

    if (event) {
      const { name, delay } = event;
      hotjarEvent(name, delay);
    }

    return next(action);
  };
